// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwapOutlinedSvg from "@fishx/icons-svg/es/asn/SwapOutlined";
import FishxIcon from '../components/FishxIcon';

var SwapOutlined = function SwapOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwapOutlinedSvg
  }));
};

SwapOutlined.displayName = 'SwapOutlined';
export default React.forwardRef(SwapOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SwapOutlined.js
// module id = 4207
// module chunks = 0